import {
  refreshCartAfterOffersPayload,
  refreshCartDiscountsAfterConsent,
} from "cart-discount-refresh";
import {
  buildOffersUrl,
  hasEthelErpId,
  shouldFetchOffers,
} from "rewards-offers-utils";

const ACTIVATE_POLL_INITIAL_DELAY_MS = 5000;
const ACTIVATE_POLL_MAX_DURATION_MS = 120_000;
const ACTIVATE_POLL_BACKOFF = 2;

const { customer } = WYATT.shopify;
const customerId = customer?.id;
const existingOffers = customer?.metafields?.ethel?.promotions;

/**
 * @param {string} url
 * @returns {Promise<object|null>}
 */
async function fetchOffersPayload(url) {
  let response;

  try {
    response = await fetch(url);
  } catch {
    return null;
  }

  if (!response.ok) {
    return null;
  }

  try {
    return await response.json();
  } catch {
    return null;
  }
}

/**
 * Poll get-or-activate until offers leave the activating state, then bump cart.
 * @returns {Promise<void>}
 */
async function activateOffersAndRefreshCart() {
  const url = buildOffersUrl({
    loggedInCustomerId: customerId,
    refresh: true,
  });

  const startedAt = Date.now();
  let delayMs = ACTIVATE_POLL_INITIAL_DELAY_MS;
  let payload = await fetchOffersPayload(url);

  while (
    payload?.status === "activating" &&
    Date.now() - startedAt < ACTIVATE_POLL_MAX_DURATION_MS
  ) {
    await new Promise((resolve) => {
      window.setTimeout(resolve, delayMs);
    });
    delayMs *= ACTIVATE_POLL_BACKOFF;
    payload = await fetchOffersPayload(
      buildOffersUrl({
        loggedInCustomerId: customerId,
        refresh: false,
      }),
    );
  }

  if (payload == null) {
    return;
  }

  const refreshed = await refreshCartAfterOffersPayload(payload);

  // Activating timed out or empty non-loaded payload — still try a cart bump
  // once in case metafields were written without a useful body.
  if (!refreshed && payload?.status !== "activating") {
    await refreshCartDiscountsAfterConsent({ ignoreOfferReadiness: true });
  }
}

if (
  customerId != null &&
  hasEthelErpId(customer) &&
  shouldFetchOffers(existingOffers) &&
  document.querySelector("rewards-offers") == null
) {
  activateOffersAndRefreshCart().catch(() => {});
}
